import { OwnerUser, User, Timing, ProposalStage } from "../..";
import { Dict } from "../../models";
import { Customer } from "./customer";
import { LeadMinimal } from "./lead";
import { PropertyDetails } from "./project";
import { Property } from "./property";

// export enum ProposalStage {
//   Proposed = "Proposed",
//   CustomerShortListInitial = "CustomerShortListInitial",
//   CustomerShortListFinal = "CustomerShortListFinal",
//   TermSheetSubmission = "TermSheetSubmission",
//   FeeConfirmation = "FeeConfirmation",
//   LetterForIntent = "LetterForIntent",
//   LegalDueDiligence = "LegalDueDiligence",
// }

export enum SiteVisitStatus {
  Draft = "Draft",
  Scheduled = "Scheduled",
  InProgress = "InProgress",
  Completed = "Completed",
  Cancelled = "Cancelled",
}
export interface Participant {
  firstName: string;
  lastName: string;
  profileImage: string;
  personalContactType: string;
  assignID: string;
  tenantID: string;
  peopleID: string;
  officialEmail: string;
  officialMobile: string;
  directNumber: string;
  assistantName: string;
  assistantNumber: string;
  associationStartDate: string;
  associationEndDate: string;
  department: string;
  designation: string;
  seniority: string;
  contactType: string;
  directorwithcompany: string;
  status: string;
}

export interface LandLord {
  customerId: string;
  projectName: string;
  projectID: string;
  contactID: number;
  propertyID: number;
  contactName: string;
  contactType: string;
  contactNumber: number;
  emailID: string;
  _id?: string;
}

export interface ParticipantOption {
  value: string;
  name: string;
  avatar: string;
}
interface PreferredDate {
  date: string;
  timing: Timing;
  _id: string;
}

interface LeadType {
  _id: string;
  name: string;
}

interface DecisionTimeFrame {
  name: string;
  _id: string;
}

interface ProductTypeInterested {
  name: string;
  _id: string;
}

interface InitialTouchPoint {
  name: string;
  _id: string;
}

interface LeadIntent {
  _id: string;
  name: string;
}

interface CompanyDetails {
  _id: string;
  name: string;
  oldPhones: string[];
}

interface LeadDetails {
  title: string;
  isDeal: boolean;
  currentStatus: string;
  isActive: boolean;
  leadType: LeadType;
  newness: string;
  decisionTimeFrame: DecisionTimeFrame;
  productTypeInterested: ProductTypeInterested;
  initialTouchPoint: InitialTouchPoint;
  buyingInfluences: any[]; // Define the correct type here
  quality: string;
  interestedProject: any[]; // Define the correct type here
  leadIntent: LeadIntent;
  _id: string;
}

interface ActivityDetails {
  title: string;
  noteType: string;
  leadId: string;
  type: string;
  triggeredBy: string;
  createdBy: {
    name: string;
    _id: string;
    accountType: string;
    email: string;
    phone: string;
  };
  isDeleted: boolean;
  isEditable: boolean;
  status: string;
  overnightTestdriveEnabled: boolean;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

interface ProposalDetails {
  masterRequirementId: string;
  createdBy: {
    name: string;
    _id: string;
    accountType: string;
    email: string;
    phone: string;
  };
  createdAt: string;
  updatedAt: string;
  status: string;
  createProposalReason: string;
  proposalType: string;
  proposalStage: string;
  customerDetails: any; // Define the correct type here
  companyDetails: CompanyDetails;
  leadDetails: LeadDetails;
  linkedActivity: string;
  activityDetails: ActivityDetails;
  _id: string;
  __v: number;
}

interface PropertyTiming {
  start: string;
  end: string;
  _id: string;
}

interface ScheduledProperty {
  date: string;
  timing: PropertyTiming;
}

interface ParticipantDetails {
  // Define the correct type here
}

interface Agent {
  // Define the correct type here
}

export interface SiteVisitList {
  _id: string;
  preferedDates: PreferredDate[];
  proposalStage: string;
  status: string;
  participants: ParticipantDetails[];
  customerDetails: any; // Define the correct type here
  companyId: string;
  companyDetails: CompanyDetails;
  leadId: string;
  leadDetails: LeadDetails;
  selectedProperties: any[]; // Define the correct type here
  selectedProjects: any[]; // Define the correct type here
  proposalId: string;
  proposalDetails: ProposalDetails;
  scheduledProperties: ScheduledProperty[];
  participantDetails: any[];
  agents: any[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface StatusCount {
  All: number;
  Draft: number;
  Scheduled: number;
  InProgress: number;
  Completed: number;
  Cancelled: number;
}
export interface Location {
  address?: string;
  latitude: number;
  longitude: number;
  coordinates: number[];
}
export interface SiteVisit {
  _id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  preferedDates: Dict[];
  proposalStage: ProposalStage;
  pickup?: Location;
  createdBy?: OwnerUser;
  drop?: Location;
  status?: SiteVisitStatus;
  participants?: CompanyUser[];
  participantIds?: number[];
  customerId?: string;
  customerDetails?: Customer;
  companyId?: string;
  companyDetails?: Dict;
  leadId?: string;
  leadDetails?: LeadMinimal;
  propertyIds?: string[];
  selectedProjects?: string[];
  proposalId?: string;
  proposalDetails?: Dict;
  agent?: OwnerUser[];
  scheduledProperties?: string[];
  scheduledDates: Dict[];
  propertyDetails: Property[];
}

export interface SiteVisitPropertyData {
  date?: Date;
  start?: string;
  end?: string;
  landlord?: User[];
  agents?: User[];
}
export interface SiteVisitPropertyUpdateData extends SiteVisitPropertyData {
  currentSelectedPropertyId?: string;
}

export interface CompanyUserDetails {
  profileImage?: string;
  personalContactType?: string;
  assignID: number;
  tenantID: number;
  peopleID: number;
  directNumber?: string;
  assistantName?: string;
  assistantNumber?: string;
  associationStartDate?: string;
  associationEndDate?: string;
  department?: string;
  designation?: string;
  seniority?: string;
  contactType?: string;
  directorwithcompany?: string;
  status?: string;
}

export interface CompanyUser extends CompanyUserDetails {
  firstName: string;
  lastName: string;
  officialEmail: string;
  officialMobile: any;
}

export interface SiteVisitScheduleDetails {
  propertyId?: string;
  landLordIds?: string[];
  agentIds?: string[];
  scheduledDate?: PreferedDate;
}
export interface PreferedDate {
  date?: Date;
  timing: Timing;
  startDate?: Date;
  endDate?: Date;
}

export interface SiteVisitSchedulePreviewDetails {
  propertyId: string;
  landLords?: User[];
  agents?: User[];
  scheduledDate?: PreferedDate;
}
export interface ScheduleSiteVisitData {
  scheduleData: SiteVisitScheduleDetails[];
}

export interface SiteVisitPropertyDetails {
  siteVisitProperties: SiteVisitProperty[];
  siteVisits: SiteVisit[];
}

export interface SiteVisitProperty {
  _id?: string;
  proposalId: string;
  propertyId: string;
  siteVisitId: string;
  masterRequirementId: string;
  proposalVersion: number;
  propertyDetails: PropertyDetails;
  status?: string;
  scheduleDetails?: SiteVisitSchedulePreviewDetails;
  visitSummary?: any;
}
